import script from "./ModalDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ModalDialog.vue?vue&type=style&index=0&id=788bd692&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-788bd692"]])

export default __exports__